<script>
    import { util } from 'vue';
    import debounce from 'lodash-es/debounce';

    export default {

    data() {
        return {
            items: [],
            query: '',
            currentQuery: '',
            previousQuery: '',
            current: -1,
            loading: false,
            selectFirst: false,
            queryParamName: 'q',
            errorStatus: null,
            hasShowAllResults: false,
        };
    },

    computed: {
        hasItems() {
            return this.items.length > 0;
        },

        isEmpty() {
            return ! this.query;
        },

        isDirty() {
            return !! this.query;
        },
    },

    methods: {
        update() {
            var $this = this;

            if ($this.loading) {
                return;
            }

            if (! $this.query) {
                return $this.reset();
            }

            if ($this.minChars && $this.query.length < $this.minChars) {
                return;
            }

            $this.loading = true;
            $this.errorStatus = null;

            (debounce(function () {
                $this.currentQuery = $this.query;

                $this.fetch().then((response) => {
                    if ($this.query) {
                        let data = response.data;
                        data = $this.prepareResponseData ? $this.prepareResponseData(data) : data;
                        $this.$emit('update');

                        setTimeout(() => {
                            $this.items = $this.limit ? data.slice(0, $this.limit) : data;
                            $this.current = -1;
                        }, 100);

                        if ($this.selectFirst) {
                            $this.down();
                        }
                    }
                }).catch((error) => {
                    console.error(error);

                    if (error && error.response) {
                        $this.errorStatus = error.response.status;
                    } else {
                        // No idea why this happens, but lets just set something so the error is
                        // displayed...
                        $this.errorStatus = 400;
                    }
                })
                .finally(() => {
                    $this.loading = false;
                    $this.previousQuery = $this.currentQuery;

                    if ($this.query && $this.query !== $this.currentQuery) {
                        $this.update();
                    }
                });
          }, 3000))();
        },

        async fetch() {
            if (! this.src) {
                return util.warn('You need to set the `src` property', this);
            }

            const src = this.queryParamName
                ? this.src
                : this.src + this.query;

            let params = this.queryParamName
                ? Object.assign({
                    [this.queryParamName]: this.query,
                    searchLegacyInfo: this.searchLegacyInfo ? 1 : 0,
                }, this.data)
                : this.data;

            if (typeof this.getRecaptchaToken === 'function') {
                await this.getRecaptchaToken('search');
            }

            if (this.recaptchaToken) {
                params = Object.assign({
                    ['recaptchaToken']: this.recaptchaToken,
                    ['recaptchaAction']: 'search',
                }, params);
            }

            return axios.get(src, { params });
        },

        reset() {
            this.items = [];
            this.query = '';
            this.loading = false;
            this.$emit('reset');
        },

        setActive(index) {
            this.current = index;
        },

        activeClass(index) {
            return {
                active: this.current === index,
            };
        },

        hit() {
            if (this.current !== -1) {
                this.onHit(this.items[this.current]);
            } else if (this.hasShowAllResults) {
                this.redirectToAllSearchResults();
            }
        },

        up() {
            if (this.current > 0) {
                this.current--;
            } else if (this.current === -1) {
                this.current = this.items.length - 1;
            } else {
                this.current = -1;
            }
        },

        down() {
            if (this.current < this.items.length - 1) {
                this.current++;
            } else {
                this.current = -1;
            }
        },

        onHit() {
            util.warn('You need to implement the `onHit` method', this);
        },

        redirectToAllSearchResults() {
            util.warn('You need to implement the `redirectToAllSearchResults` method', this);
        },
    },
};
</script>
